import Index from './index.vue'
import Create from './components/Create.vue'
import List from './components/List.vue'
import Edit from './components/Edit.vue'

export default [
  {
    path: 'campaign',
    name: 'campaign',
    component: Index,
    title: 'Campaign',
    redirect: { name: 'campaign-list' },
    children: [
      {
        path: 'list',
        name: 'campaign-list',
        component: List,
      },
      {
        path: 'create',
        name: 'campaign-create',
        component: Create,
      },
      {
        path: ':id/edit',
        name: 'campaign-edit',
        component: Edit,
      },
    ],
  },
]
